// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lT8pglb9UN_Tv28TJ4xa {
    width: 600px;
    height: 40%;
    padding: 20px 40px 20px 40px;
    position: relative;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
    background-color: #fff;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: "Nunito Sans", Sans-serif, serif;
}

.rKnDDSv8euVpB85H7JPQ {
    width: 100%;
    text-align: center;
    font-size: 24px;
    color: #004BA0;
    margin-bottom: 10px;
}

.e2NptUpL0yQZPysJgONs {
    display: flex;
    width: 100%;
    justify-content: center;
}

.DXX2VOIU8491Ibnzp3ye {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 18px;
}

.DXX2VOIU8491Ibnzp3ye:hover {
    cursor: pointer;
}
.ZadilSkYo9oE_gOvjaAe {
    border: solid #1976D2;
    background-color: white;
    border-radius: 10px;
    position: absolute;
    left: 57%;
    top: 20vh;
    z-index: 1
}
.ZadilSkYo9oE_gOvjaAe tr {
    border: solid 0.1px #E0E0E0;
}
.ZadilSkYo9oE_gOvjaAe th {
    padding: 0 10px;
    color: #004BA0;
    text-align: initial;
    font-size: 14px;
}
.ZadilSkYo9oE_gOvjaAe tr span {
    color: #004BA0;
    font-size: 12px;
    padding: 0 10px;
    text-wrap: nowrap;
}
.ZadilSkYo9oE_gOvjaAe td {
    text-align: center;
    padding: 0;
}
.ZadilSkYo9oE_gOvjaAe img {
    width: 20px
}

@media screen and (max-width: 600px) {
    .ZadilSkYo9oE_gOvjaAe {
        border: none;
        width: 100%;
        border-radius: 0;
        position: initial;
    }
    .ZadilSkYo9oE_gOvjaAe table {
        width: 100%;
    }
    .ZadilSkYo9oE_gOvjaAe th {
        padding: 10px;
    }
    .ZadilSkYo9oE_gOvjaAe tr span {
        font-size: 15px;
        padding: 10px 20px;
    }
    .ZadilSkYo9oE_gOvjaAe td {
        padding: 1px;
    }
    .lT8pglb9UN_Tv28TJ4xa {
        width: 90%;
        height: 250px;
        padding: 10px;
    }
    .rKnDDSv8euVpB85H7JPQ {
        font-size: 16px;
        margin-bottom: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/css/add-collaboration-popup.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,kBAAkB;IAClB,0CAA0C;IAC1C,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT;AACJ;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;QACV,aAAa;QACb,aAAa;IACjB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".card_container {\n    width: 600px;\n    height: 40%;\n    padding: 20px 40px 20px 40px;\n    position: relative;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\n    background-color: #fff;\n    border-radius: 6px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    font-family: \"Nunito Sans\", Sans-serif, serif;\n}\n\n.card_title {\n    width: 100%;\n    text-align: center;\n    font-size: 24px;\n    color: #004BA0;\n    margin-bottom: 10px;\n}\n\n.button_container {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n}\n\n.close_image {\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    width: 18px;\n}\n\n.close_image:hover {\n    cursor: pointer;\n}\n.rolePopUp {\n    border: solid #1976D2;\n    background-color: white;\n    border-radius: 10px;\n    position: absolute;\n    left: 57%;\n    top: 20vh;\n    z-index: 1\n}\n.rolePopUp tr {\n    border: solid 0.1px #E0E0E0;\n}\n.rolePopUp th {\n    padding: 0 10px;\n    color: #004BA0;\n    text-align: initial;\n    font-size: 14px;\n}\n.rolePopUp tr span {\n    color: #004BA0;\n    font-size: 12px;\n    padding: 0 10px;\n    text-wrap: nowrap;\n}\n.rolePopUp td {\n    text-align: center;\n    padding: 0;\n}\n.rolePopUp img {\n    width: 20px\n}\n\n@media screen and (max-width: 600px) {\n    .rolePopUp {\n        border: none;\n        width: 100%;\n        border-radius: 0;\n        position: initial;\n    }\n    .rolePopUp table {\n        width: 100%;\n    }\n    .rolePopUp th {\n        padding: 10px;\n    }\n    .rolePopUp tr span {\n        font-size: 15px;\n        padding: 10px 20px;\n    }\n    .rolePopUp td {\n        padding: 1px;\n    }\n    .card_container {\n        width: 90%;\n        height: 250px;\n        padding: 10px;\n    }\n    .card_title {\n        font-size: 16px;\n        margin-bottom: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card_container": `lT8pglb9UN_Tv28TJ4xa`,
	"card_title": `rKnDDSv8euVpB85H7JPQ`,
	"button_container": `e2NptUpL0yQZPysJgONs`,
	"close_image": `DXX2VOIU8491Ibnzp3ye`,
	"rolePopUp": `ZadilSkYo9oE_gOvjaAe`
};
export default ___CSS_LOADER_EXPORT___;
